
import * as __star__ from '@clayui/pagination-bar';

const {
default: __default__,
ClayPaginationBarWithBasicItems,
__esModule
} = __star__;

export {
ClayPaginationBarWithBasicItems,
__esModule
};
export default __default__;
